import { Component } from "react";
import IconButton from "../../components/IconButton";
import { closeRoom } from "../../connection/config";
import { canCopyToClipboard, getServerJoinUrl } from "../../utilities";
import BrandHeader from "../BrandHeader";
import CopyButton from "../CopyButton";

import Close from "../../assets/icons/close.svg";

import "./CenterBox.css";

function selectUrl() {
    window.getSelection().removeAllRanges();
    window.getSelection().selectAllChildren(document.querySelector(".qm-join-summary-url"));
}

class CenterBox extends Component {

    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
    }

    onCancel(navigate) {
        if (this.props.closeRoomSignal) {
            // Include hostToken for authorization (getHostToken prop provided by host views)
            const hostToken = this.props.getHostToken ? this.props.getHostToken() : null;
            this.props.socket.emit(closeRoom, this.props.game.hostingRoom.roomCode, hostToken);
        } else {
            navigate("/");
        }
    }

    renderJoinInfo() {
        const copyButtonClass = canCopyToClipboard()
            ? "qm-join-summary-copy-button"
            : "qm-join-summary-copy-button-disabled";
        if (true === this.props.renderJoinInfo) {
            return (
                <div className="qm-join-summary">
                    <div>
                        Join:
                    </div>
                    <div className="qm-join-summary-url" onClick={selectUrl}>{
                        getServerJoinUrl(this.props.game.hostingRoom.roomCode)
                    }</div>
                    <div className={copyButtonClass}>
                        <CopyButton text={getServerJoinUrl(this.props.game.hostingRoom.roomCode)} variant="default" />
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }

    renderLogo() {
        if (!this.props.logo) return null;
        // Use "host" variant for host views (detected via closeRoomSignal or renderJoinInfo)
        const isHostView = this.props.closeRoomSignal || this.props.renderJoinInfo;
        const variant = isHostView ? "host" : "player";
        // Default to "hero" size unless explicitly set to "compact"
        const size = this.props.logoSize || "hero";
        return <BrandHeader size={size} variant={variant} />;
    }

    render() {
        return (
            <div className="outer">
                {this.renderJoinInfo()}
                <div className="middle">
                    <div className="inner">
                        {this.renderLogo()}
                        {this.props.children}
                    </div>
                </div>
                {this.props.cancel && (
                    <IconButton
                        icon={this.props.cancelIcon || Close}
                        label={this.props.cancel}
                        containerClassName="cancel-btn"
                        buttonClassName="qm-fixed-top qm-fixed-left"
                        onClick={this.onCancel}
                    />
                )}
            </div>
        );
    }
}

export default CenterBox;
